export default {
  common: {
    product: 'Product',
    features: 'Features',
    useCase: 'Use Case',
    events: 'Event Registration',
    polls: 'Polls',
    quizzes: 'Online Quizzes',
    surveys: 'Surveys',
    integrations: 'Integrations',
    templates: 'Templates',
    pricing: 'Pricing',
    comparison: 'Comparison',
    blog: 'Blog',
    login: 'Sign in',
    signup: 'Get Started — FREE',
    tryFree: 'Create your first form',
    useTemplate: 'Use this template',
    userStoryHead: 'User Story',
    resources: 'Resources',
    watchdemo: 'Watch a Demo'
  },
  metadata: {
    home: {
      title:
        'HeyForm: Open source form builder, built for small business success',
      description:
        'Build conversational forms, surveys, and quizzes with HeyForm. Free and open source to self-host, with paid Cloud plans for managed hosting.'
    },
    aboutUs: {
      title: 'About Us | Get to Know HeyForm',
      description:
        "Learn more about HeyForm, our mission, and how we're revolutionizing the way you create forms. Join us on our journey!"
    },
    contact: {
      title: 'Get in Touch with Us | HeyForm',
      description:
        "Have questions or need support? Contact the HeyForm team today. We're here to help you with all your form-building needs."
    },
    pricing: {
      title: 'HeyForm Pricing & Plans | Compare Plans & Choose the Best',
      description:
        "Explore HeyForm's pricing plans, compare features, and find the perfect fit. Get answers to FAQs on our Pricing & Plans page."
    },
    product: {
      title: 'Features - HeyForm',
      description:
        "Explore HeyForm's feature-packed platform. Create customizable online forms with advanced tools for seamless data collection, analytics, and integration. No coding needed."
    }
  },
  footer: {
    resources: 'Resources',
    gettingStarted: 'Getting Started',
    helpCenter: 'Help Center',
    privacy: 'Privacy Policy',
    terms: 'Terms & Conditions',
    company: 'Company',
    about: 'About',
    faq: 'FAQ',
    contact: 'Contact',
    stayConnected: 'Stay Connected',
    changelog: 'Changelog',
    Community: 'Community',
    Climate: 'Climate Pledge'
  },
  home: {
    bannerHeadline1: 'The open-source Typeform alternative',
    bannerHeadline: 'Boost user engagement with personalized forms.',
    bannerDesc:
      'Simplify data collection, engage users, and achieve meaningful results - all while staying budget-friendly.',
    bannerSocialProof: 'Daily choice of {count} happy users',
    usageTitle: 'Start with a template, not from scratch',
    usageDesc:
      'Pick a ready-made form and customize it in seconds. No blank pages, no guesswork.',
    usageCreators: 'For creators',
    usageCreators1: 'Contact form',
    usageCreators2: 'Customer feedback survey',
    usageCreators3: 'Workshop Registration Form',
    usageProduct: 'For product teams',
    usageProduct1: 'Product feedback survey',
    usageProduct2: 'Product registration form',
    usageProduct3: 'Product order form',
    usageMarketing: 'For marketing',
    usageMarketing1: 'Free trial form',
    usageMarketing2: 'Lead capture form',
    usageMarketing3: 'Referral form',
    usageHR: 'For HR teams',
    usageHR1: 'Exit interview form',
    usageHR2: 'Job application form',
    usageHR3: 'Employee satisfaction survey',
    usageSupport: 'For support teams',
    usageSupport1: 'Client satisfaction survey',
    usageSupport2: 'Brand survey form',
    usageSupport3: 'Customer testimonials form',
    usageEducation: 'For education',
    usageEducation1: 'Student enrollment form',
    usageEducation2: 'Teacher feedback form',
    usageEducation3: 'Student survey form',
    usageCTA: 'Browse all templates',
    brandHeadline: 'Trusted by brands spanning different industries',
    testimonialTitle: 'People love HeyForm',
    testimonialDesc:
      'Fans from around the world go the extra mile to show how much they love creating forms with HeyForm.'
  },
  product: {
    bannerHeadline: 'Create forms users love to complete',
    bannerSubheadline:
      'Create UX-first quizzes, polls, surveys, and events with our people-friendly form builder—no coding required!',
    featureHeadline: "It's simple, but it just works great!",
    integrationsHeadline: 'It’s ready to sync with what you use',
    integrationSubheading:
      'Streamline your workflow with seamless integration of your everyday tools.',
    integrations: [
      {
        title: 'Slack'
      },
      {
        title: 'Airtable'
      },
      {
        title: 'Zapier'
      },
      {
        title: 'WordPress'
      },
      {
        title: 'HubSpot'
      },
      {
        title: 'Dropbox'
      },
      {
        title: 'Mailchimp'
      },
      {
        title: 'Monday'
      },
      {
        title: 'Telegram'
      },
      {
        title: 'Google Drive'
      },
      {
        title: 'Google Analytics'
      },
      {
        title: 'Lark Suite'
      }
    ],
    integrationButtom: 'Check out all the integrations',
    ctaHeading: "If you don't know, don't guess.",
    ctaSubheading:
      'Create a HeyForm, and ask your audience for the answers you need.'
  },
  integrations: {
    bannerHeadline: 'Send form data where it needs to go',
    bannerText:
      'Automatically connect HeyForm with your tools — from analytics and CRM to payments and automation — no manual work required.'
  },
  blog: {
    bannerHeadline: 'Make better forms',
    bannerText: 'Things we find interesting, our learning and our expertise.'
  },
  pricing: {
    questionsHeadLine: 'Frequently Asked Questions',
    questionsSubhead: 'Haven’t found what you’re looking for? Try the',
    questionsA: 'Help Center',
    questionsA2: 'Contact us',
    questions: [
      {
        title: 'What payment methods do you accept?',
        answer:
          'We accept credit cards and debit cards via Stripe. Bank transfer is also supported by contacting our support.'
      },
      {
        title: 'Is HeyForm really free?',
        answer:
          'Unlike some of the competitors, HeyForm provides a real free plan without time limit. Once you sign up, you automatically subscribe to our Free plan.'
      },
      {
        title: 'Can I upgrade my plan anytime?',
        answer:
          'Yes! You can upgrade your plan anytime you want, our billing system will calculate the price gap automatically, so you just need to simply pay the new invoice to complete the upgrade.'
      },
      {
        title: 'Can I belong to multiple teams on HeyForm?',
        answer:
          'Yes! You can use the same email address to create and join multiple teams. However, each one of these workspaces is on its own plan and needs to be upgraded individually.'
      }
    ]
  },
  aboutUs: {
    bannerHeadline: 'Our Story',
    bannerText: 'This is why we’re building HeyForm.',
    teamHeadline: 'Meet the Minds Behind HeyForm',
    teamSubhead: 'The Brains, the Code, the AI Agents, and maybe You?',
    members: [
      {
        name: 'Luo Baishun',
        position: 'Co-founder'
      },
      {
        name: 'Wu Qin',
        position: 'Co-founder'
      },
      {
        name: 'ChatGPT',
        position: 'Chief Executive Officer'
      }
    ],
    joinusHeadline: 'Join Our Growing Team',
    joinussubHead:
      'We are looking for active brains and good souls. Looking for a great place to deliver your best work? We might just have a workstation with your name on it!',
    joinusA: 'Join us, make a change '
  },
  contact: {
    bannerHeadline: 'Get in touch',
    bannerSubhead:
      'Questions? Feedback? Just want to say hi? Fill out the form below, and we’ll get back to you soon!'
  },
  templates: {
    bannerHeadline: ['Start with a template. Launch in minutes.'],
    bannerSubhead:
      'Browse ready-made forms for lead generation, feedback, surveys, and more — fully customizable and built for completion.'
  }
}
